module.exports = __webpack_public_path__ + "dashboard/img/analitics.d9c879c5804540e8c74b27a205004f20.svg";